import { render, staticRenderFns } from "./NgsIcon.vue?vue&type=template&id=066fa81e&scoped=true&"
import script from "./NgsIcon.vue?vue&type=script&lang=js&"
export * from "./NgsIcon.vue?vue&type=script&lang=js&"
import style0 from "./NgsIcon.vue?vue&type=style&index=0&id=066fa81e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066fa81e",
  null
  
)

export default component.exports